/* eslint-disable react/no-danger, no-warning-comments */
/* TODO: Remove dangerouslySetInnerHTML Calls */
import React from 'react';
import styles from './css/Obituary.styl';
import SourceGroup from '../SourceGroup';
import _ from 'lodash';
import {Collapse} from '../../../../shared/library';
import {gaClickHandler} from '../../../../shared/utilities/GAHelpers';
import {
  isFuneralHomePageType,
  isBatesvillePageType,
  isForestLawnPageType,
} from '../../../../shared/utilities/personPageType';
import classNames from 'classnames';
import {
  OBIT_TYPE_MEMORIAM,
  OBIT_TYPE_LEGACY,
  OBIT_TYPE_TRIBUTES_UNPAID,
  OBIT_TYPE_INTERNATIONAL_UNPAID,
  OBIT_TYPE_INTERNATIONAL_PAID,
} from '../../../../shared/utilities/constants';
import {FlowerIcon} from '../../../../shared/Svgs';

/**
 * The obituary section of the person page
 * @param   {Object}  props Passed in properties
 * @return  {JSX}     Returns the obituary section
 */
export default class Obituary extends React.Component {
  static propTypes = {
    firstName: React.PropTypes.string,
    flowerClickEvents: React.PropTypes.func,
    flowersLink: React.PropTypes.string,
    funeralHomeAttribution: React.PropTypes.string,
    hasPrimaryObit: React.PropTypes.bool,
    parentLayout: React.PropTypes.object,
    personPageType: React.PropTypes.string,
    primaryDisplayTextObit: React.PropTypes.object,
    primaryFuneralHome: React.PropTypes.object,
    showFlowers: React.PropTypes.bool,
    showReadMore: React.PropTypes.bool,
    sourceGroup: React.PropTypes.array,
    textToDisplay: React.PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };

    const {personPageType, sourceGroup: sources} = props;

    this.toggleObitText = this.toggleObitText.bind(this);

    this.teaserText = _.get(props.textToDisplay, 'teaser');
    this.fullText = _.get(props.textToDisplay, 'full');

    this.isSingleTributesUnpaid = false;
    this.isLegacySourced = false;

    this.sourceCount = _.size(sources);

    this.memoriamCount = 0;
    this.internationalCount = 0;

    this.renderedObits = this.getRenderedObits(_.cloneDeep(sources));

    this.headerText = this.getHeaderText(
      this.sourceCount,
      this.memoriamCount,
      this.internationalCount,
      personPageType
    );
  }

  /**
   * Returns if module should be in right column
   * @param  {object} layout object of layout definitions
   * @return {string}        return 'right' or null
   */
  getLayoutInfo(layout) {
    const hasObituary =
      _.indexOf(_.get(layout, 'map.dual.right', []), 'obituary') !== -1;
    const isSingleColumn = _.get(layout, 'columns', 'dual') === 'single';

    return {
      isSingleColumn,
      isRightColumn: !isSingleColumn && hasObituary ? 'ObituaryRight' : false,
    };
  }

  /**
   * Toggles the obit text collapse/expand
   * @method toggleObitText
   * @return {undefind} returns nothing
   */
  toggleObitText() {
    this.setState(prevState => ({isExpanded: !prevState.isExpanded}));
  }

  /**
   * Gets the rendered obits and counts their type
   * @param   {array} sources the list of obituaries, memoriams, or notices
   * @return  {array} returns each source with the read more text
   */
  getRenderedObits(sources) {
    return _.map(sources, obit => {
      const obitType = _.get(obit, 'obituaryType');

      if (this.sourceCount === 1) {
        this.isSingleTributesUnpaid = obitType === OBIT_TYPE_TRIBUTES_UNPAID;
        this.isLegacySourced = obitType === OBIT_TYPE_LEGACY;
      }

      switch (obitType) {
        case OBIT_TYPE_MEMORIAM:
          this.memoriamCount++;
          obit.showReadMore = true;
          obit.readMoreText = 'Read Memoriam';
          break;
        case OBIT_TYPE_INTERNATIONAL_UNPAID:
          this.internationalCount++;
          obit.showReadMore = true;
          obit.readMoreText = 'Read Funeral Notice';
          break;
        case OBIT_TYPE_INTERNATIONAL_PAID:
          this.internationalCount++;
          obit.showReadMore = true;
          obit.readMoreText = 'Read Notice';
          break;
        default:
          obit.showReadMore = false;
          obit.readMoreText = 'Read More';
      }

      return obit;
    });
  }

  /**
   * Gets the correct header text
   * @param  {number} sourceCount         the total number of sources
   * @param  {number} memoriamCount       the number of memoriams
   * @param  {number} internationalCount  the number of international notices
   * @param  {boolean} personPageType    the type of person page
   * @return {object} returns the header text for obits and sources
   */
  getHeaderText(
    sourceCount,
    memoriamCount,
    internationalCount,
    personPageType
  ) {
    const useSingluar = sourceCount < 2;
    const isPartnerPageType = isFuneralHomePageType(personPageType);
    const isBatesville = isBatesvillePageType(personPageType);

    let text = {
      obituary: useSingluar ? 'Obituary' : 'Obituaries',
      sourceGroup: isPartnerPageType ? 'Other Sources' : 'Read Full Obituary',
    };
    const display = {
      international: {
        obituary: useSingluar ? 'Notice' : 'Notices',
        sourceGroup: isPartnerPageType ? 'Other Sources' : 'Read Full Notice',
      },
      memoriam: {
        obituary: useSingluar ? 'Memoriam' : 'Memoriams',
        sourceGroup: isPartnerPageType ? 'Other Sources' : 'Read Full Memoriam',
      },
    };

    if (isBatesville) {
      text.sourceGroup = 'Printed Obituaries';
      display.international.sourceGroup = 'Printed Notices';
      display.memoriam.sourceGroup = 'Printed Memoriams';
    }

    if (sourceCount > 0) {
      if (sourceCount === memoriamCount) {
        text = display.memoriam;
      } else if (sourceCount === internationalCount) {
        text = display.international;
      }
    }

    return text;
  }

  /**
   * React Component render.
   * @return {JSX} Obituary rendered.
   */
  render() {
    const {
      hasPrimaryObit,
      flowerClickEvents,
      flowersLink,
      funeralHomeAttribution,
      primaryDisplayTextObit,
      firstName,
      parentLayout,
      personPageType,
      showReadMore,
      showFlowers,
    } = this.props;

    const {isRightColumn, isSingleColumn} = this.getLayoutInfo(parentLayout);
    const hasCollapsableText =
      (isSingleColumn || isRightColumn) &&
      _.size(this.fullText) > _.size(this.teaserText);
    const showFlowersLink =
      !isRightColumn &&
      !isSingleColumn &&
      _.isFunction(flowerClickEvents) &&
      flowersLink &&
      showFlowers;

    return hasPrimaryObit ? (
      <section className={classNames(styles.Obituary, styles[isRightColumn])}>
        <div className={styles.header}>
          <h2>{this.headerText.obituary}</h2>
          {showFlowersLink ? (
            <a
              className={styles.flowersLink}
              data-ga-no-auto-tag
              href={flowersLink}
              onClick={flowerClickEvents}
              target="_blank"
            >
              <span>
                <FlowerIcon />
              </span>
              Send Flowers
            </a>
          ) : null}
        </div>
        <div className={styles.columns}>
          {isForestLawnPageType(personPageType) &&
          funeralHomeAttribution &&
          !isRightColumn ? (
            <div className={styles.columnLeft}>
              <h2>{funeralHomeAttribution} Obituary</h2>
            </div>
          ) : null}
          {isRightColumn && !isSingleColumn ? (
            <div className={styles.columnRight}>
              <h2>
                {firstName ? `${firstName}'s ` : ''}
                {this.headerText.obituary}
              </h2>
            </div>
          ) : null}
        </div>
        {isBatesvillePageType(personPageType) || showReadMore ? (
          <div className={styles.container}>
            <p dangerouslySetInnerHTML={{__html: this.teaserText}} />
            <a
              className={styles.readMoreButton}
              data-ga-no-auto-tag="true"
              href={primaryDisplayTextObit.href}
              onClick={gaClickHandler(
                'bypage_person',
                'readmore_nearobittextbutton_click',
                primaryDisplayTextObit
              )}
              target="_blank"
            >
              Read More
            </a>
          </div>
        ) : (
          <div className={styles.container}>
            {hasCollapsableText ? (
              <div>
                <Collapse baseHeight={120} in={this.state.isExpanded}>
                  <div aria-hidden={!this.state.isExpanded}>
                    <p dangerouslySetInnerHTML={{__html: this.fullText}} />
                  </div>
                </Collapse>
                <div className={styles.showMore} onClick={this.toggleObitText}>
                  {this.state.isExpanded ? 'Show Less' : 'Show More'} &rsaquo;
                </div>
              </div>
            ) : (
              <p dangerouslySetInnerHTML={{__html: this.fullText}} />
            )}
          </div>
        )}
        {this.sourceCount === 0 ? null : (
          <SourceGroup
            isLegacySourced={this.isLegacySourced}
            isSingleTributesUnpaid={this.isSingleTributesUnpaid}
            position={isRightColumn || ''}
            renderedObits={this.renderedObits}
            sourceHeaderText={this.headerText.sourceGroup}
          />
        )}
      </section>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/Obituary/Obituary.js